import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function TechStack() {
  return (
    <div className="space-y-20">

      {/* COMMON HERO */}
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          Tech Stack
        </h1>
        <p className="text-md text-slate-600 max-w-3xl">
          EventFlow uses a stable and proven technology stack focused on
          reliability and long-term maintainability.
        </p>
      </section>

      {/* STACK FLOW */}
      <section className="relative pl-8 border-l-2 border-[#C9A24E]/40 space-y-16">

        {[
          {
            title: "Frontend Layer",
            desc: "HTML, CSS, and Bootstrap 5 power the user interface.",
            tech: "HTML • CSS • Bootstrap 5",
            detail:
              "Ensures responsive layouts, consistent UI components, and faster development.",
            logos: [
              "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
              "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
              "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
            ],
          },
          {
            title: "Backend Layer",
            desc: "Core application logic and workflows live here.",
            tech: "Laravel",
            detail:
              "Handles authentication, validation, booking logic, and secure REST APIs.",
            logos: [
              "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
            ],
          },
          {
            title: "Database Layer",
            desc: "All operational data is stored securely.",
            tech: "MySQL",
            detail:
              "Stores bookings, payments, expenses, suppliers, and historical reports.",
            logos: [
              "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
            ],
          },
        ].map((item, i) => (
          <div key={i} className="relative">
            <span className="absolute -left-[11px] top-1 h-5 w-5 rounded-full bg-[#C9A24E]" />

            <h2 className="text-xl font-semibold mb-3 ml-5">
              {item.title}
            </h2>

            <p className="text-slate-600 max-w-3xl mb-4 ml-5">
              {item.desc}
            </p>

            <div className="bg-white border rounded-lg p-6 max-w-3xl ml-5">

              {/* LOGOS */}
              <div className="flex items-center gap-4 mb-3">
                {item.logos.map((logo, idx) => (
                  <img
                    key={idx}
                    src={logo}
                    alt={item.tech}
                    className="h-8"
                  />
                ))}
              </div>

              <p className="font-medium mb-1">{item.tech}</p>
              <p className="text-sm text-slate-600">{item.detail}</p>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-slate-100 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-6">
          Supporting Practices
        </h2>

        <div className="flex flex-wrap gap-3">
          {[
            "API-first design",
            "Role-based access control",
            "Server-side validation",
            "Secure authentication",
            "Modular codebase",
            "Scalable architecture",
          ].map((item, i) => (
            <span
              key={i}
              className="px-4 py-2 bg-white border rounded-full text-sm text-slate-700"
            >
              {item}
            </span>
          ))}
        </div>
      </section>

      {/* NEXT */}
      {/* <section className="border-t pt-8 mt-12">
        <p className="text-slate-600">
          Next, explore{" "}
          <Link to="/docs/who-is-this-for" className="font-medium text-[#C9A24E]">
            Who EventFlow Is For
          </Link>{" "}
          and how different roles benefit from the system.
        </p>
      </section> */}
         <DocNavigation
        previous={{
          title: "System Architecture",
          link: "/docs/system-architecture"
        }}
        next={{
          title: "Who Is This For?",
          link: "/docs/who-is-this-for"
        }}
      />
    </div>
  );
}


